import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import ErrorMessage from '../components/ErrorMessage'
import ArqueosBaqueiraList from '../components/ArqueosBaqueiraList'
import { fetchArqueosBaqueira } from '../actions/arqueosbaqueira'
import LoadingProgress from '../components/LoadingProgress'
import '../styles/ArqueosBaqueiraView.css'

class ArqueosBaqueiraView extends React.Component {
  constructor(props) {
    super(props)

    // Default to the current month — the fetch is limited to one month
    // to keep the payload small (each arqueo embeds its full tickets array).
    const now = new Date()
    const defaultMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`

    this.state = {
      month: defaultMonth,
    }

    this.fetchMonth = this.fetchMonth.bind(this)
    this.handleMonthChange = this.handleMonthChange.bind(this)
    this.refreshArqueos = this.refreshArqueos.bind(this)
  }

  componentDidMount() {
    this.fetchMonth(this.state.month);
  }

  monthRange(month) {
    const [year, m] = month.split('-').map(Number)
    const lastDay = new Date(year, m, 0).getDate()
    return {
      start: `${month}-01`,
      end: `${month}-${String(lastDay).padStart(2, '0')}`,
    }
  }

  fetchMonth(month) {
    const { start, end } = this.monthRange(month)
    this.props.fetchArqueosBaqueira(start, end)
  }

  handleMonthChange(e) {
    const month = e.target.value
    if (!month) return
    this.setState({ month })
    this.fetchMonth(month)
  }

  refreshArqueos() {
    this.fetchMonth(this.state.month)
  }

  render() {
    const { arqueosbaqueira, error, loading } = this.props;
    const { month } = this.state;

    // Client-side month guard: keeps the picker working even if the API
    // ignores the StartDate/EndDate params (pre-deploy). Once the API
    // filters server-side this is a no-op.
    const [year, m] = month.split('-').map(Number)
    const monthArqueos = (arqueosbaqueira || []).filter(arqueo => {
      const d = new Date(arqueo.date)
      return d.getFullYear() === year && d.getMonth() + 1 === m
    })

    return (
      <div className="abq-view">
        {/* Header Section */}
        <div className="abq-header">
          <h1 className="abq-title">
            <i className="fas fa-cash-register"></i>
            ARQUEOS BAQUEIRA
          </h1>
          <div className="abq-month">
            <label>Mes</label>
            <input
              type="month"
              value={month}
              onChange={this.handleMonthChange}
            />
          </div>
        </div>

        {error ? (
          <ErrorMessage message={error.message} />
        ) : (!arqueosbaqueira || loading) ? (
          <LoadingProgress />
        ) : (
          <ArqueosBaqueiraList
            arqueosbaqueira={monthArqueos}
            refreshArqueos={this.refreshArqueos}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  arqueosbaqueira: state.arqueosbaqueira.arqueosbaqueira,
  error: state.arqueosbaqueira.error,
  loading: state.arqueosbaqueira.loading,
});

const mapDispatchToProps = (dispatch) => ({
  fetchArqueosBaqueira: bindActionCreators(fetchArqueosBaqueira, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ArqueosBaqueiraView);
